<template>
  <div id="OurBrandPage">
    <section
      class="hero is-black is-fullheight"
      style="background-color: #000000"
    >
      <div class="hero-body">
        <div class="container">
          <div
            class="columns custom-columns is-variable is-1-mobile is-0-tablet is-3-desktop is-8-widescreen is-2-fullhd"
          >
            <div class="column">
              <img class="max-width-80" src="@/assets/brands/beerbar.jpg" />
              <h1 class="title">Craft Beers</h1>
              <h2 class="subtitle">
                2+4 is newest craft beer bar in Bangkok with variety of Thai and
                international craft beer and live music
              </h2>
              <section>
                <b-button type="is-warning">Click Me</b-button>
              </section>
            </div>

            <div class="column">
              <img class="max-width-80" src="@/assets/brands/winebar.jpg" />
              <h1 class="title">Secret Beverages</h1>
              <h2 class="subtitle">
                The most happening rooftop bar in Bangkok with visual media
                mapping on the space. We are serving a variety of alcohol
                beverages.
              </h2>
              <section>
                <b-button type="is-primary">Click Me</b-button>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "OurBrandPage",
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
.max-width-80 {
  max-width: 70%;
  padding: 1.5rem;
}

@media (max-width: 767px) {
  /* <== You can change this break point as per your  needs */
  .custom-columns {
    flex-direction: column-reverse;
    display: flex;
  }
}
</style>
